var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showCoordinateCard
        ? _c(
            "b-card",
            {
              staticClass: "menu-bg-blue-transparent",
              staticStyle: { "overflow-x": "hidden" },
              attrs: { id: "coordinateCard", "no-body": "" },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "px-2 text-center",
                          attrs: { "align-v": "center" },
                        },
                        [
                          _c("b-col", [
                            _c("div", { staticClass: "smCoords" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    this.format
                                      ? this.googleCoords
                                      : this.qgisCoords
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c("b-col", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  this.format
                                    ? this.googleCoordsLabel
                                    : this.qgisCoordsLabel
                                ) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "fontAwesomeAttr" },
                    [
                      _c("fa", {
                        staticClass: "float-right m-1",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          icon: ["fas", "window-close"],
                          title: "Close",
                          size: "sm",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("showCoordCard", false)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("fa", {
                        staticClass: "float-right m-1",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          icon: ["fas", "exchange-alt"],
                          title: "Swap Format",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.swapLongLat()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("fa", {
                        staticClass: "float-right m-1",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          icon: ["fas", _vm.clipboardIcon],
                          title: "Copy Coordinates",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.copyCoordinates()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }